import { BaseError } from "src/contexts/_shared/domain/errors/BaseError";

export class InvalidDocumentWithContentTypeError extends BaseError {
  constructor(reason: string) {
    super(`Invalid Document Content type: ${reason}`);
  }
}
